import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      class: "s-header-logo",
      style: {"max-width":"512px"},
      src: `${_ctx.REGION_ENVIRONMENT}/images/not_found_data.svg`,
      alt: "Данные не найдены"
    }, null, 8, _hoisted_1)
  ]))
}